import * as $ from "jquery";
import axios from "axios";
import {url} from "../utilities";

export const mobileAds = () => {
    let image = null;

    $("#addMobileAd input[type='file'].dragndrop, #editMobileAd input[type='file'].dragndrop").change(function () {
        const files = $(this).prop('files');
        if (files.length > 0) {
            const reader = new FileReader();
            reader.onloadend = function () {
                image = reader.result;
                generatePreview();
            }
            reader.readAsDataURL(files[0]);
        }
    })

    let uploaded_image_input = $('input[name="uploaded_image"]');
    if($("#editMobileAd").length > 0 && uploaded_image_input.length > 0 && uploaded_image_input.val()) {
        image = uploaded_image_input.val();
    }

    $("#addMobileAd, #editMobileAd").on('file_delete', function() {
        image = null;
        generatePreview();
    })

    $('input[name="background"], input[name="vertical_alignment"], input[name="horizontal_alignment"]')
        .on('change', () => generatePreview())

    const iframe = $('iframe#preview');
    const view_html = $('input[name="view_html"]');
    if(view_html.length > 0) {
        iframe.contents().find('html').html(view_html.val());
    }

    const generatePreview = async () => {
        try {
            const response = await axios.post(url(`api/admin/mobile-ads/preview`), {
                image,
                background: $('input[name="background"]').val(),
                vertical_alignment: $('input[name="vertical_alignment"]:checked').val(),
                horizontal_alignment: $('input[name="horizontal_alignment"]:checked').val()
            });

            iframe.contents().find('html').html(response.data.html);
        } catch (err) {}
    }

    $('input[name="field_title"]').on('input', function() {
        $('#preview-container-title').text($(this).val())
    })
}
